<template>
  <div id="container" class="mainWrap">
    <div class="mainCon conWrap">
      <div class="mainLogin">
        <div class="visual">
          <p class="tit">
            메리츠화재<br />
            <span>적하보험</span>
          </p>
          <p class="txt">
            운송중 발생하는 여러위험으로부터<br />
            고객 여러분의 재산을 보호해 드립니다.
          </p>
        </div>
        <div class="login" v-show="state.lginState == '2'">
          <div class="tit">
            <p><span class="fw700">로그인</span> 해주세요.</p>
            <div class="radio">
              <input
                type="radio"
                @click="athType('inqOut')"
                name="loginType"
                id="loginType1"
                value="1"
                checked
              />
              <label for="loginType1">조회출력</label>
            </div>
            <div class="radio">
              <input
                type="radio"
                @click="athType('SubInput')"
                name="loginType"
                id="loginType2"
                value="2"
              />
              <label for="loginType2">청약입력</label>
            </div>
          </div>
          <div class="form">
            <input
              id="logid"
              v-model="state.logid"
              type="text"
              placeholder="아이디 입력"
              title="아이디 입력"
            />
            <input
              id="logpw"
              v-model="state.logpw"
              type="password"
              placeholder="비밀번호 입력"
              title="비밀번호 입력"
            />
            <input
              id="logbirth"
              v-model="state.logbirth"
              v-if="state.athTypeCd == 1"
              maxlength="6"
              type="birthday"
              placeholder="생년월일 입력"
              title="생년월일 입력"
            />
            <a @click="login()"><span>로그인</span></a>
          </div>
          <div class="btn">
            <div class="checkbox">
              <input type="checkbox" id="idSave" />
              <label for="idSave">ID저장</label>
            </div>
            <a @click="termsCond()"><span>인터넷약정서</span></a>
            <router-link to="/mbrChk"><span>회원가입</span></router-link>
            <router-link to="/lostIdPwd"
              ><span>ID 비밀번호찾기</span></router-link
            >
          </div>
        </div>
        <div class="logout" v-show="state.lginState == '1'">
          <div class="tit">
            <p><span class="fw700">고객님,</span> 반갑습니다.</p>
          </div>
          <div class="form">
            <a @click="logout()"><span>로그아웃</span></a>
          </div>
        </div>
      </div>

      <div class="mainFavorite">
        <h2><span class="fcRed">즐겨찾는</span> 메뉴</h2>
        <ul>
          <li>
            <router-link to="/insurEstForm"
              ><span>보험료견적</span></router-link
            >
          </li>
          <li>
            <router-link to="/sbcpInpInqNdPolOtpt"
              ><span>청약입력</span></router-link
            >
          </li>
          <li>
            <router-link to="/subsRstList"><span>청약결과</span></router-link>
          </li>
          <li>
            <router-link to="/unpaidList"><span>미납조회</span></router-link>
          </li>
          <li>
            <router-link to="/getPolList"><span>증권출력</span></router-link>
          </li>
          <li>
            <router-link to="/subsChangeForm"
              ><span>증권간략정정</span></router-link
            >
          </li>
        </ul>
      </div>

      <div class="mainInfo">
        <div class="grayBox">
          <h2>
            로그인 증권출력<br />
            <span class="fcRed">오류처리</span>
          </h2>
          <div class="customer">
            <dl>
              <dt>업무시간</dt>
              <dd>평일 9시 ~ 18시</dd>
            </dl>
            <dl>
              <dt>전화번호</dt>
              <dd>02-3786-2777</dd>
            </dl>
          </div>
        </div>
        <div class="grayBox">
          <h2>
            한국외환은행<br />
            <span class="fcRed">오늘의 환율</span>
            <em>(기준일자) {{ state.currDate }}</em>
          </h2>
          <div class="exchange">
            <table>
              <caption>
                한국외환은행 오늘의 환율
              </caption>
              <colgroup>
                <col width="26" />
                <col width="90" />
                <col width="90" />
                <col width="90" />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th scope="col" class="tac">기준율</th>
                  <th scope="col" class="tac">매입율</th>
                  <th scope="col" class="tac">매도율</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    <img src="@/assets/images/imgNationEn.png" alt="미국" />
                  </th>
                  <td class="tac">{{ state.USD?.stdExrt }}</td>
                  <td class="tac">{{ state.USD?.buyExrt }}</td>
                  <td class="tac">{{ state.USD?.sllgExrt }}</td>
                </tr>
                <tr>
                  <th scope="row">
                    <img src="@/assets/images/imgNationJp.png" alt="일본" />
                  </th>
                  <td class="tac">{{ state.JPY?.stdExrt }}</td>
                  <td class="tac">{{ state.JPY?.buyExrt }}</td>
                  <td class="tac">{{ state.JPY?.sllgExrt }}</td>
                </tr>
                <tr>
                  <th scope="row">
                    <img src="@/assets/images/imgNationEu.png" alt="유럽연합" />
                  </th>
                  <td class="tac">{{ state.EUR?.stdExrt }}</td>
                  <td class="tac">{{ state.EUR?.buyExrt }}</td>
                  <td class="tac">{{ state.EUR?.sllgExrt }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PopPwChange ref="popPwChangeRef" @close="test"></PopPwChange>
  <loginAthChk ref="loginAthChkRef" @success="successOfapvAth"></loginAthChk>
</template>

<script setup>
// @ is an alias to /src
import { ref, reactive, inject, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import CryptoJS from "crypto-js";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useFormValidation from "@/common/validation";
import useDialog from "@/common/dialog";
import { globalState } from "@/common/globalState";
import loginAthChk from "@/components/common/layerPop/loginAthChk.vue";
import PopPwChange from "@/components/common/layerPop/PopPwChange.vue";

const router = useRouter();
const store = useStore();
const swalAlert = inject("swalAlert");
const swalConfirmPw = inject("swalConfirmPw");
const axios = inject("axios");

const loginAthChkRef = ref(null);
const popPwChangeRef = ref(null);
const state = reactive({
  currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
  rtrnAnimInsYn: false,
  mode: process.env.NODE_ENV,
  athTypeCd: 1,
  currDate: util.formatDate(new Date(), "yyyymmdd"),
  curCd: {},
  USD: {},
  JPY: {},
  EUR: {},
  VND: {},
  lginState: "2",
  logid: "",
  logpw: "",
  logbirth: "",
  loginTypeCd: "",

  keyResult: {},
});

const athType = (type) => {
  switch (type) {
    case "inqOut":
      state.athTypeCd = 1;
      break;
    case "SubInput":
      state.athTypeCd = 2;
      break;
  }
};

const login = async () => {
  state.keyResult = await axios.json("/getCryptoKey.do");

  const key = state.keyResult.data.key;
  const iv = state.keyResult.data.iv;
  const keyBytes = CryptoJS.enc.Base64.parse(key);
  const ivBytes = CryptoJS.enc.Base64.parse(iv);

  const encryptedId = CryptoJS.AES.encrypt(state.logid, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
  }).toString();
  const encryptedPw = CryptoJS.AES.encrypt(state.logpw, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
  }).toString();
  const encryptedBdt = CryptoJS.AES.encrypt(state.logbirth, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
  }).toString();

  //조회출력
  if (state.athTypeCd == 1) {
    if (_.isEmpty(state.logid)) {
      return swalAlert("아이디를 입력하세요.");
    } else if (_.isEmpty(state.logpw)) {
      return swalAlert("패스워드를 입력하세요.");
    } else if (_.isEmpty(state.logbirth)) {
      return swalAlert("생년월일을 입력하세요.");
    }

    let agentFullInfo = window.navigator.userAgent;
    let index = agentFullInfo.match(/OS\s\d+/gm);
    if (!_.isEmpty(index)) {
      return swalAlert("모바일에서 처리가 불가능합니다");
    }

    let param = {};
    param.encId = encryptedId;
    param.encPw = encryptedPw;
    param.encBdt = encryptedBdt;
    param.login_typ_cd = state.athTypeCd;
    param.flag = "T";
    param.skipPwChg = "Y"; // 비밀번호 90 여부 확인
    axios.json("/login.do", param).then(async function (result) {
      if (result.data.state == "N") {
        store.commit("common/chgLginChk", false);
        store.commit("common/lginAuthChk", "");
        if (result.data.pwChgYn == "Y") {
          // 비밀번호 변경 필요
          result.data.msg =
            "비밀번호를 변경하신지 90일이 지났습니다. 비밀번호를 변경해주세요.<br>변경하시겠습니까?";
          return swalConfirmPw(result.data.msg).then((res) => {
            console.log(res);
            if (res.isConfirmed) {
              // 변경
              popPwChangeRef.value.open({
                login_id: state.logid,
                biz_no: result.data.bizNo,
              });
            } else {
              // 나중에 변경 그냥 로그인 진행
              let param1 = {};
              param1.encId = encryptedId;
              param1.encPw = encryptedPw;
              param1.encBdt = encryptedBdt;
              param1.login_typ_cd = state.athTypeCd;
              param1.flag = "T";
              param1.skipPwChg = "N";
              axios.json("/login.do", param1).then(async function (res) {
                if (res.data.state == "N") {
                  store.commit("common/chgLginChk", false);
                  store.commit("common/lginAuthChk", "");
                  return swalAlert(res.data.msg);
                } else {
                  if (res.data.msg != null) {
                    swalAlert(res.data.msg);
                  }
                  store.commit("common/chgLginChk", true);
                  store.commit("common/lginAuthChk", res.data.lginAuth);
                  store.commit("common/loginTypeCdChk", 1);
                  await load();
                  axios.json("/logHisLdg.do", {
                    memo: "조회 로그인",
                    page: window.location.hash,
                  });
                  state.lginState = "1";
                  state.logbirth = "";
                  state.logpw = "";
                  state.logid = "";
                }
              });
            }
          });
        }
        return swalAlert(result.data.msg);
      } else {
        if (result.data.msg != null) {
          swalAlert(result.data.msg);
        }
        store.commit("common/chgLginChk", true);
        store.commit("common/lginAuthChk", result.data.lginAuth);
        store.commit("common/loginTypeCdChk", 1);
        await load();
        axios.json("/logHisLdg.do", {
          memo: "조회 로그인",
          page: window.location.hash,
        });
        state.lginState = "1";
        state.logbirth = "";
        state.logpw = "";
        state.logid = "";
      }
    });
  } //청약입력
  else if (state.athTypeCd == 2) {
    if (_.isEmpty(state.logid)) {
      return swalAlert("아이디를 입력하세요.");
    } else if (_.isEmpty(state.logpw)) {
      return swalAlert("패스워드를 입력하세요.");
    }

    let agentFullInfo = window.navigator.userAgent;
    let index = agentFullInfo.match(/OS\s\d+/gm);
    if (!_.isEmpty(index)) {
      return swalAlert("모바일에서 처리가 불가능합니다");
    }

    let param = {};
    param.encId = encryptedId;
    param.encPw = encryptedPw;
    param.login_typ_cd = state.athTypeCd;
    param.skipPwChg = "Y"; // 비밀번호 변경 조건 변수
    axios.json("/loginYnChk.do", param).then(async function (result) {
      if (result.data.state == "N") {
        store.commit("common/chgLginChk", false);
        store.commit("common/lginAuthChk", "");
        if (result.data.pwChgYn == "Y") {
          // 비밀번호 변경 필요
          result.data.msg =
            "비밀번호를 변경하신지 90일이 지났습니다. 비밀번호를 변경해주세요.<br>변경하시겠습니까?";
          return swalConfirmPw(result.data.msg).then((res) => {
            if (res.isConfirmed) {
              // 변경
              popPwChangeRef.value.open({
                login_id: state.logid,
                biz_no: result.data.bizNo,
              });
            } else {
              // 나중에 변경
              let param1 = {};
              param1.encId = encryptedId;
              param1.encPw = encryptedPw;
              param1.login_typ_cd = state.athTypeCd;
              param1.skipPwChg = "N"; // 비밀번호 변경 조건 변수
              axios.json("/loginYnChk.do", param1).then(async function (res) {
                if (res.data.state == "N") {
                  store.commit("common/chgLginChk", false);
                  store.commit("common/lginAuthChk", "");
                  return swalAlert(res.data.msg);
                } else if (res.data.state == "Y") {
                  let param = {};
                  param.logid = state.logid;
                  param.logpw = state.logpw;
                  param.encId = encryptedId;
                  param.encPw = encryptedPw;
                  param.login_typ_cd = state.athTypeCd;
                  param.corpNo = res.data.corpNo;
                  param.mstr_id_yn = res.data.mstr_id_yn;
                  param.athdc_mbdy_enc = res.data.athdc_mbdy_enc;
                  console.log("복호화 데이터");
                  console.log(param.athdc_mbdy_enc);

                  if (res.data.athdc_efct_flag == "1") {
                    //관리자가 아니고 유효기간 만료시
                    await swalAlert(res.data.msg);
                    param.UpdateAthdc = 1;
                    loginAthChkRef.value.open(param);
                  } else if (res.data.athdc_efct_flag == "2") {
                    //관리자가 아니고 유효기간 O
                    param.UpdateAthdc = 2;
                    loginAthChkRef.value.open(param);
                  } else {
                    // 관리자
                    let param2 = {};
                    param2.encId = encryptedId;
                    param2.encPw = encryptedPw;
                    param2.login_typ_cd = state.athTypeCd;
                    param2.flag = "T";
                    axios
                      .json("/login.do", param2)
                      .then(async function (result1) {
                        //복호화 --> 암호화 로직
                        // axios.json('/userdel.do', param).then(async function(result1){
                        // 	console.log(result1)
                        // })
                        // let param = {};
                        // param.login_id = 'm9999018';
                        // axios.json('/unlockUsr.do', param).then(function(result){
                        // 	return swalAlert(result.data.msg).then((result) => {
                        // 		axios.json('/logHisLdg.do', {memo:"관리자 LOCK 해제",page:window.location.hash});
                        // 		// admMgr();
                        // 	});
                        // })
                        if (result1.data.state == "N") {
                          store.commit("common/chgLginChk", false);
                          store.commit("common/lginAuthChk", "");
                          if (result1.data.msg != null) {
                            return swalAlert(result1.data.msg);
                          }
                        } else {
                          if (result1.data.msg != null) {
                            swalAlert(result1.data.msg);
                          }
                          store.commit("common/chgLginChk", true);
                          store.commit(
                            "common/lginAuthChk",
                            result1.data.lginAuth
                          );
                          store.commit("common/loginTypeCdChk", 1);
                          await load();
                          state.lginState = "1";
                          state.logbirth = "";
                          state.logpw = "";
                          state.logid = "";
                        }
                      });
                  }
                }
              });
            }
          });
        }
        return swalAlert(result.data.msg);
      } else if (result.data.state == "Y") {
        let param = {};
        param.logid = state.logid;
        param.logpw = state.logpw;
        param.encId = encryptedId;
        param.encPw = encryptedPw;
        param.login_typ_cd = state.athTypeCd;
        param.corpNo = result.data.corpNo;
        param.mstr_id_yn = result.data.mstr_id_yn;
        param.athdc_mbdy_enc = result.data.athdc_mbdy_enc;
        console.log("복호화 데이터");
        console.log(param.athdc_mbdy_enc);

        if (result.data.athdc_efct_flag == "1") {
          //관리자가 아니고 유효기간 만료시
          await swalAlert(result.data.msg);
          param.UpdateAthdc = 1;
          loginAthChkRef.value.open(param);
        } else if (result.data.athdc_efct_flag == "2") {
          //관리자가 아니고 유효기간 O
          param.UpdateAthdc = 2;
          loginAthChkRef.value.open(param);
        } else {
          //관리자
          let param = {};
          param.encId = encryptedId;
          param.encPw = encryptedPw;
          param.login_typ_cd = state.athTypeCd;
          param.flag = "T";
          axios.json("/login.do", param).then(async function (result) {
            //복호화 --> 암호화 로직
            // axios.json('/userdel.do', param).then(async function(result1){
            // 	console.log(result1)
            // })
            // let param = {};
            // param.login_id = 'm9999018';
            // axios.json('/unlockUsr.do', param).then(function(result){
            // 	return swalAlert(result.data.msg).then((result) => {
            // 		axios.json('/logHisLdg.do', {memo:"관리자 LOCK 해제",page:window.location.hash});
            // 		// admMgr();
            // 	});
            // })
            if (result.data.state == "N") {
              store.commit("common/chgLginChk", false);
              store.commit("common/lginAuthChk", "");
              if (result.data.msg != null) {
                return swalAlert(result.data.msg);
              }
            } else {
              if (result.data.msg != null) {
                swalAlert(result.data.msg);
              }
              store.commit("common/chgLginChk", true);
              store.commit("common/lginAuthChk", result.data.lginAuth);
              store.commit("common/loginTypeCdChk", 1);
              await load();
              state.lginState = "1";
              state.logbirth = "";
              state.logpw = "";
              state.logid = "";
            }
          });
        }
      }
    });
  }
};

const successOfapvAth = (sessionUserInfo) => {
  store.commit("common/chgLginChk", true);
  store.commit("common/lginAuthChk", sessionUserInfo.userInfo.ind_corp_typ_cd);
  store.commit("common/loginTypeCdChk", 2);
  load();
  axios.json("/logHisLdg.do", {
    memo: "청약 로그인",
    page: window.location.hash,
  });
  state.lginState = "1";
  state.logbirth = "";
  state.logpw = "";
  state.logid = "";
};

const termsCond = () => {
  store.commit("common/commitCorpNo", "");
  router.push({ name: "termsCond" });
};

const logout = () => {
  axios.json("/logout.do", {}).then(function (result) {
    if (result.data.state == "Y") {
      store.commit("common/chgLginChk", false);
      store.commit("common/lginAuthChk", "");
      state.lginState = "2";
      load();
    }
  });
};

onMounted(async () => {
  //오늘의 환율
  const result = await axios.transaction("FNGCTGCO0008", {
    stdDt: state.currDate,
    curCd: "",
  });
  state.USD = _.filter(result.body.row, (a) => a.curCd == "USD")[0];
  state.JPY = _.filter(result.body.row, (a) => a.curCd == "JPY")[0];
  state.EUR = _.filter(result.body.row, (a) => a.curCd == "EUR")[0];
  await load();
  store.commit("common/exChangeChk", state.USD);
  console.log(sessionUserInfo);

  if (!_.isEmpty(sessionUserInfo)) {
    state.lginState = "1";
  }
  state.keyResult = await axios.json("/getCryptoKey.do");
});

watch(
  () => store.state.common.lginChk,
  (newVal, oldVal) => {
    if (!newVal) {
      state.lginState = "2";
    }
  }
);
</script>

<style></style>
